// sort-imports-ignore

import * as Sentry from '@sentry/vue'

import type { App } from 'vue'

import type { SentryConfig } from '#vue-shared-lib/types/sentry'

export const createSentryPlugin = (config: SentryConfig) => ({
  install: (app: App) => {
    if (config?.dsn && !window.location.host.startsWith('localhost')) {
      console.log('Sentry initialized')

      Sentry.init({
        app,
        dsn: config.dsn,
        release: config.release,
        environment: config.environment,
        integrations: [
          Sentry.browserTracingIntegration({
            router: config.router,
          }),
          Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
            maskAllInputs: true,
          }),
        ],
        attachProps: true,
        attachStacktrace: true,
        tracePropagationTargets: [config.tracingOrigin],
        replaysSessionSampleRate: config.replaysSessionSampleRate ?? 0,
        replaysOnErrorSampleRate: config.replaysOnErrorSampleRate ?? 0,
      })
    }
  },
})
